/* eslint-disable */
// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  GetIsoCountryCodesData,
  GetIsoCountryCodesErrors,
  GetIsoCountryCodesResponses,
  GetProductActivityByCountryData,
  GetProductActivityByCountryErrors,
  GetProductActivityByCountryResponses,
  GetProductLastSessionSummaryData,
  GetProductLastSessionSummaryErrors,
  GetProductLastSessionSummaryResponses,
  GetProductLocationsData,
  GetProductLocationsErrors,
  GetProductLocationsResponses,
  GetProductTypeByCountryData,
  GetProductTypeByCountryErrors,
  GetProductTypeByCountryResponses,
  GetSingleLocationData,
  GetSingleLocationErrors,
  GetSingleLocationResponses,
} from './types.gen';
import {
  zGetIsoCountryCodesResponse,
  zGetProductActivityByCountryQuery,
  zGetProductActivityByCountryResponse,
  zGetProductLastSessionSummaryQuery,
  zGetProductLastSessionSummaryResponse,
  zGetProductLocationsQuery,
  zGetProductLocationsResponse,
  zGetProductTypeByCountryQuery,
  zGetProductTypeByCountryResponse,
  zGetSingleLocationQuery,
  zGetSingleLocationResponse,
} from './zod.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const getProductActivityByCountry = <ThrowOnError extends boolean = false>(
  options: Options<GetProductActivityByCountryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProductActivityByCountryResponses,
    GetProductActivityByCountryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetProductActivityByCountryQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetProductActivityByCountryResponse.parseAsync(data),
    url: '/v1/product-location/activity-by-country',
    ...options,
  });

export const getProductLastSessionSummary = <ThrowOnError extends boolean = false>(
  options: Options<GetProductLastSessionSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProductLastSessionSummaryResponses,
    GetProductLastSessionSummaryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetProductLastSessionSummaryQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetProductLastSessionSummaryResponse.parseAsync(data),
    url: '/v1/product-location/summary',
    ...options,
  });

export const getProductTypeByCountry = <ThrowOnError extends boolean = false>(
  options: Options<GetProductTypeByCountryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProductTypeByCountryResponses,
    GetProductTypeByCountryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetProductTypeByCountryQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetProductTypeByCountryResponse.parseAsync(data),
    url: '/v1/product-location/product-types-by-country',
    ...options,
  });

export const getProductLocations = <ThrowOnError extends boolean = false>(
  options: Options<GetProductLocationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProductLocationsResponses,
    GetProductLocationsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetProductLocationsQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetProductLocationsResponse.parseAsync(data),
    url: '/v1/product-location/locations',
    ...options,
  });

export const getSingleLocation = <ThrowOnError extends boolean = false>(
  options: Options<GetSingleLocationData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetSingleLocationResponses, GetSingleLocationErrors, ThrowOnError>(
    {
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: zGetSingleLocationQuery,
          })
          .parseAsync(data),
      responseValidator: async (data) => await zGetSingleLocationResponse.parseAsync(data),
      url: '/v1/product-location/singlelocation',
      ...options,
    },
  );

export const getIsoCountryCodes = <ThrowOnError extends boolean = false>(
  options?: Options<GetIsoCountryCodesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetIsoCountryCodesResponses,
    GetIsoCountryCodesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetIsoCountryCodesResponse.parseAsync(data),
    url: '/v1/product-location/meta-data/iso_country_codes',
    ...options,
  });
